import axios from "axios";

export const excludedReasonApi = {
    getExcludedReasons(projectId: number): Promise<any> {
        return axios.get(`projects/${projectId}/excluded-reason`);
    }
}